"use client";

import * as Portal from "@radix-ui/react-portal";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/common/Toast/Toast";
import { useToast } from "@/components/common/Toast/useToast";

export function Toaster() {
  const { toasts } = useToast();

  const viewportClassName = toasts.at(-1)?.viewportClassName ?? "sm:top-0";

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, viewportClassName, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}

      <Portal.Root className={"text-pale z-60"}>
        <ToastViewport className={viewportClassName} />
      </Portal.Root>
    </ToastProvider>
  );
}
